import { Theme } from '@mui/material/styles'
export const styles = {
  checkboxStyles: {},

  formSection: {
    display: 'flex',
    flexDirection: 'column',
    padding: (theme: Theme) => `${theme.spacing(1)} ${theme.spacing(2)}`,
  },
}

export const matchedCardStyles = {
  card: {
    width: '100%',
  },
  content: {
    fontFamily: 'Source Sans Pro',
    fontSize: '14px',
  },
  heading: {
    fontFamily: 'Source Sans Pro Bold',
    fontSize: '24px',
  },
  listItem: {
    root: {
      display: 'block',
    },
  },
}
